import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export const ns = 'entities';
export const keyPrefix = 'login_form';
export const useLoginFormTranslation = (): UseTranslationResponse<typeof ns> => useTranslation(ns, { keyPrefix });
export const ruRu = ({
  [keyPrefix]: {
    login: {
      placeholder: 'Email',
      required: 'Поле обязательно для заполнения',
      regex: 'Неверный формат email',
    },
    password: {
      placeholder: 'Пароль',
      required: 'Поле обязательно для заполнения',
    },
    submit: 'Войти',
  },
}) as Record<string, unknown>;
export const en = ({
  [keyPrefix]: {
    login: {
      placeholder: 'Email',
      required: 'This field is required',
      regex: 'Invalid email format',
    },
    password: {
      placeholder: 'Password',
      required: 'This field is required',
    },
    submit: 'Login',
  },
}) as Record<string, unknown>;
export const esEs = ({
  [keyPrefix]: {
    login: {
      placeholder: 'Correo electrónico',
      required: 'Este campo es obligatorio',
      regex: 'Formato de correo electrónico no válido',
    },
    password: {
      placeholder: 'Contraseña',
      required: 'Este campo es obligatorio',
    },
    submit: 'Acceso',
  },
}) as Record<string, unknown>;
export const ptBr = ({
  [keyPrefix]: {
    login: {
      placeholder: 'Email',
      required: 'Este campo é obrigatório',
      regex: 'Formato de e-mail inválido',
    },
    password: {
      placeholder: 'Senha',
      required: 'Este campo é obrigatório',
    },
    submit: 'Conecte-se',
  },
}) as Record<string, unknown>;
